import {
  LOADING_SIGNUP,
  SIGNUP_FAILED,
  SIGNUP_INVALID_OTP,
  SIGNUP_INVALID_DOB,
  SIGNUP_INVALID_EMAIL,
  SIGNUP_INVALID_TELNOCC,
  SIGNUP_INVALID_MOBILENUMBER,
  SIGNUP_INVALID_PASSWORD,
  SIGNUP_INVALID_FIRSTNAME,
  SIGNUP_INVALID_LASTNAME,
  SIGNUP_INVALID_COUNTRY,
  SIGNUP_INVALID_ACNTTYPE,
  SIGNUP_INVALID_WALLETOWNNERID,
  SIGNUP_INVALID_PLATFORMID,
  SIGNUP_INVALID_CURRENCY,
  SIGNUP_INVALID_MOBILEOTP,
  SIGNUP_INVALID_EMAILOTP,
  SIGNUP_INVALID_TERMSCONSENT,
  SIGNUP_INVALID_COUNTRYCODE,
  SIGNUP_INVALID_ADDRDETAILS,
  SIGNUP_INVALID_THANA,
  SIGNUP_INVALID_UNION,
  SIGNUP_SUCCESS,
  RESET_SIGNUP,
} from "../types";

const initialState = {
  isLoading: false,
  isFailed: false,
  isError: false,
  isInvalidOTP: false,
  isSuccess: false,
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SIGNUP:
      return {
        ...state,
        isLoading: true,
        isFailed: false,
        isInvalidOTP: false,
        isError: false,
        isSuccess: false,
        status: "",
      };
    case SIGNUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        isFailed: false,
        isInvalidOTP: false,
        status: "Your account has been verified.",
      };

    case SIGNUP_FAILED:
      return {
        ...state,
        isSuccess: false,
        isLoading: false,
        isError: false,
        isFailed: true,
        isInvalidOTP: false,
        status: "Send OTP failed",
      };

    case SIGNUP_INVALID_PASSWORD:
    case SIGNUP_INVALID_DOB:
    case SIGNUP_INVALID_EMAIL:
    case SIGNUP_INVALID_ADDRDETAILS:
    case SIGNUP_INVALID_FIRSTNAME:
    case SIGNUP_INVALID_MOBILENUMBER:
    case SIGNUP_INVALID_TELNOCC:
    case SIGNUP_INVALID_OTP:
    case SIGNUP_INVALID_ACNTTYPE:
    case SIGNUP_INVALID_COUNTRY:
    case SIGNUP_INVALID_LASTNAME:
    case SIGNUP_INVALID_WALLETOWNNERID:
    case SIGNUP_INVALID_COUNTRYCODE:
    case SIGNUP_INVALID_TERMSCONSENT:
    case SIGNUP_INVALID_EMAILOTP:
    case SIGNUP_INVALID_MOBILEOTP:
    case SIGNUP_INVALID_CURRENCY:
    case SIGNUP_INVALID_PLATFORMID:
    case SIGNUP_INVALID_UNION:
    case SIGNUP_INVALID_THANA:
      return {
        ...state,
        isSuccess: false,
        isLoading: false,
        isError: false,
        isFailed: false,
        isInvalidOTP: true,
        status: "Invalid OTP, Please try again",
      };

    case RESET_SIGNUP:
      return (state = initialState);

    default:
      return state;
  }
};
